import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "bulma-switch-control/css/main.min.css";
import 'bulma/css/bulma.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <App />
);

